var plugin_rtlignore_default = {
  "alignLeft": "-fNW7",
  "textWrapNowrap": "OamnY",
  "alignRight": "-q0YV",
  "alignCenter": "_7Nm-V",
  "sizeFullWidth": "vUgNK",
  "renderedInTable": "qESjX",
  "sizeOriginal": "tNkWd",
  "sizeContent": "IvmNK",
  "sizeSmall": "cRkAW",
  "sizeSmallCenter": "URYRk",
  "flex": "jmqLt",
  "atomic": "tqAje",
  "anchor": "_0shKh",
  "embed": "Z8HSQ",
  "horizontalScrollbar": "_8Dh7l",
  "pluginContainerMobile": "_8EtGd"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore.scss.js.map
